import { type FC } from "react";

import { default as SuppressibleConfirmationModal } from "../../../../../../components/modal/SuppressibleConfirmationModalTs";
import { type IModalManager } from "../../../../../../interfaces/IModalManager";

export interface CancelEmailSendConfirmationModalProps {
  modalManager: IModalManager;
}

export const CancelSendSessionModal: FC<CancelEmailSendConfirmationModalProps> = ({ modalManager }) => {
  const message = <div>If you cancel this scheduled email send(s), they will not be sent.</div>;

  return (
    <>
      <SuppressibleConfirmationModal
        className="send-email-popup"
        title={`Cancel Scheduled Send?`}
        message={message}
        confirmButtonName={"Cancel Send"}
        cancelButtonName={"Keep"}
        checkboxIsHidden
        modalManager={modalManager}
      />
    </>
  );
};
